import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';
import SEOHead from '../../../components/feature/SEOHead';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (authError) {
      setError('Invalid email or password. Access denied.');
    } else {
      navigate('/admin');
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <SEOHead
        title="Admin Login | CallOfDutyNext.com"
        description="Admin login — authorized personnel only."
        canonical="/admin/login"
        noIndex
      />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: 'repeating-linear-gradient(45deg,#fff 0px,#fff 1px,transparent 1px,transparent 14px)' }}
      />
      <div className="relative w-full max-w-sm">
        <div className="text-center mb-8">
          <a href="/" className="inline-block">
            <span className="font-['Barlow_Condensed'] font-black text-2xl tracking-tight text-white">
              CALLOFDUTY<span className="text-[#00ff41]">NEXT</span>
            </span>
          </a>
          <h1 className="font-['Barlow_Condensed'] font-bold text-white text-3xl mt-6 mb-1">Admin Access</h1>
          <p className="text-gray-500 text-sm">Secure panel — authorized personnel only</p>
        </div>

        <form onSubmit={handleLogin} className="bg-[#111] border border-[#1f1f1f] rounded-lg p-8 space-y-5">
          {error && (
            <div className="bg-red-900/20 border border-red-800/40 text-red-400 text-sm px-4 py-3 rounded-md">
              <i className="ri-error-warning-line mr-2" />{error}
            </div>
          )}
          <div>
            <label className="block text-gray-400 text-xs font-['Barlow_Condensed'] font-bold tracking-widest uppercase mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@callofduty.next"
              className="w-full bg-[#0a0a0a] border border-[#2a2a2a] text-white text-sm rounded-md px-4 py-3 focus:outline-none focus:border-[#00ff41]/50 placeholder-gray-600 transition-colors"
            />
          </div>
          <div>
            <label className="block text-gray-400 text-xs font-['Barlow_Condensed'] font-bold tracking-widest uppercase mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="w-full bg-[#0a0a0a] border border-[#2a2a2a] text-white text-sm rounded-md px-4 py-3 focus:outline-none focus:border-[#00ff41]/50 placeholder-gray-600 transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#00ff41] hover:bg-[#00e63a] text-black font-['Barlow_Condensed'] font-black text-lg tracking-widest py-3 rounded-md transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <i className="ri-loader-4-line animate-spin" /> AUTHENTICATING
              </span>
            ) : (
              'ENTER COMMAND CENTER'
            )}
          </button>
        </form>

      </div>
    </div>
  );
}
